import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, TextField, Typography, } from '@mui/material';
import { LoadingButton } from '@mui/lab';
export const TradingActivityConfirmationMultipleDialog = ({ open, settingsData, loading, clientName, onClose, onConfirm, }) => {
    const [confirmationText, setConfirmationText] = useState('');
    useEffect(() => {
        if (open) {
            setConfirmationText('');
        }
    }, [open]);
    if (!open || !settingsData) {
        return null;
    }
    const TradingOptions = {
        buy_disabled: 'BUY activity',
        sell_disabled: 'SELL activity',
        withdrawal_disabled: 'WITHDRAWAL activity',
    };
    const clientCheckName = clientName || 'this client';
    const isConfirmationDisabled = confirmationText !== clientName || loading;
    return (React.createElement(Dialog, { open: open, maxWidth: 'sm', fullWidth: true, onClose: onClose },
        React.createElement(DialogTitle, null, "Update client settings"),
        React.createElement(DialogContent, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(Alert, { color: 'error', severity: 'error', variant: 'outlined' },
                "You are about to change following settings:",
                React.createElement(List, null, Object.keys(settingsData).map((k) => {
                    const key = k;
                    return (React.createElement(Box, { key: key, sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                        "\u2022",
                        React.createElement(Box, null,
                            React.createElement("b", null,
                                " ",
                                TradingOptions[key],
                                " "),
                            " ",
                            React.createElement("span", null, " to "),
                            ' ',
                            React.createElement("b", null,
                                " ",
                                settingsData[key] ? 'Disabled' : 'Enabled'))));
                })),
                "For the client ",
                React.createElement("b", null, clientCheckName)),
            React.createElement(Typography, { variant: 'body2' },
                "To confirm, please type ",
                clientName,
                " below:"),
            React.createElement(TextField, { size: 'small', placeholder: `Type ${clientName} to confirm`, value: confirmationText, onChange: (e) => {
                    setConfirmationText(e.target.value);
                } })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onClose }, "Cancel"),
            React.createElement(LoadingButton, { disabled: isConfirmationDisabled, variant: 'contained', onClick: onConfirm }, "Yes, update setting"))));
};
